import Link from 'next/link';
import Button from '@/components/Button';

import Container from '@/components/Container';
import Logo from '@/components/Logo';

import { useAuth } from '@/hooks/useAuth';

function Greeting() {
	const {
		isLoggedIn,
		logIn,
		logOut,
		user: { name }
	} = useAuth();
	
	return (
		<div>
			{ isLoggedIn ? (
				<div className="flex justify-start gap-x-4">
					<div className="self-center">
						{ name ? `Hi, ${ name }` : 'Hello!' }
					</div>
					
					<div>
						<Button variant="outline" size="medium" onClick={ logOut }>Sign-out</Button>
					</div>
				</div>
			) : (
				<div className="flex gap-x-4 ">
					<Button variant="outline" size="medium" onClick={ logIn }>Sign-in</Button>
				</div>
			)}
		</div>
	);
}

export default function SiteHeader() {
	return (
		<Container>
			<div className="flex justify-between items-center">
				<Link href="/dashboard">
					<Logo />
				</Link>

				<Greeting />
			</div>
		</Container>
	);
}
